import React from 'react';

function About() {
  const leaders = [
    { name: 'Purna Mohanty', title: 'Founder and CEO', img: './images/leaders/Purna.jpg' },
    { name: 'Ramana Rao', title: 'Chief Technology Officer', img: './images/leaders/Ramana.png' },
    { name: 'Suchitra Pattnaik', title: 'Programs and Process', img: './images/leaders/Suchitra.png' },
    { name: 'Jeetu Kar', title: 'Simulation Engineering', img: './images/leaders/Jeetu.jpg' },
    { name: 'Benedict Joseph Guevarra', title: 'Simulation Engineering', img: './images/leaders/Benny.jpg' },
    { name: 'Rocky Arce', title: 'Software Engineering', img: './images/leaders/Rocky.jpg' },
    { name: 'Abinash Sahu', title: 'Software Engineering', img: './images/leaders/Abi.jpg' },
    { name: 'Hara Prasad Mohanty', title: 'CFO & VP of APAC Operations', img: './images/leaders/Hara.jpg' },
    { name: 'Niranjan Tripathy', title: 'Chief People Officer', img: './images/leaders/Niranjan.jpg' },
  ];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 AboutBanner text-white text-center d-flex align-items-center justify-content-center py-5">
            <div className="inner-heading">
              <h1 className="text-uppercase display-5">About Us</h1>
              <p className="blockquote d-none">Achieves Best-In-Class Power Performance, Area, Schedule</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        {/* About Intro */}
        <section className="text-center mb-5">
          <h3 className="text-uppercase text-mcolor mb-4">About Marquee Semiconductor</h3>
          <p>
            Marquee Semiconductor is an innovative provider of semiconductor design services with technical expertise in connectivity.
            Our company was founded in July 2019 to work with customers as partners and strive to provide design services do deliver advanced SoCs and chiplets.
            We utilize our connectivity skills to provide customers with both engineering resources and turnkey services, depending on their preferences and requirements.
            With engineering sites around the world – India, Philippines, Singapore, Malaysia and the USA, Marquee differentiates itself through a policy of
            Innovation, Integrity, and Transparency in all of our customer engagements.
          </p>
          <p>
            We take a fully transparent approach to how we provide customers with services so our clients always know exactly how a project is progressing, in real-time. Give us a chance to work with you and we’ll show you.
          </p>
        </section>

        {/* Vision & Mission */}
        <section className="row align-items-center mb-5">
          <div className="col-md-6">
            <h3 className="text-uppercase text-mcolor mb-3">Our Vision <span className="text-info">&</span> Mission</h3>
            <h5 className="text-uppercase text-mcolor mt-4">Vision</h5>
            <p>
              We believe that connectivity within and between chips is a critical aspect of modern semiconductor designs. Our vision is to leverage this know-how to make our customers’ products perform at their highest potential and to make them successful in the marketplace.
            </p>
            <h5 className="text-uppercase text-mcolor mt-4">Mission</h5>
            <p>
              To leverage our connectivity experience, know-how & skills to deliver advanced designs on schedule and within budget.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src="./images/mission-vision.jpg" alt="Vision and Mission" className="img-fluid rounded" />
          </div>
        </section>

        {/* Values */}
        <section className="mb-5">
          <h3 className="text-uppercase text-mcolor mb-4">Values</h3>
          <img src="./images/values.png" alt="Marquee Semiconductor Core Values" className="img-fluid rounded" />
        </section>

        {/* Leadership */}
        <section>
          <h3 className="text-uppercase text-mcolor text-center mb-4">Leadership</h3>
          <div className="row justify-content-center">
            {leaders.map((leader, index) => (
              <div key={index} className="col-6 col-sm-6 col-md-3 text-center mb-4">
                <img
                  src={leader.img}
                  alt={leader.name}
                  className="img-fluid rounded-circle mb-3 shadow"
                  style={{ maxWidth: '250px', height: '250px', objectFit: 'cover' }}
                />
                <h6 className="text-mcolor mb-0">{leader.name}</h6>
                <small className="text-muted">{leader.title}</small>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default About;
